import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  CardMedia,
  CardActionArea,
  Chip,
  Stack,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Slide,
  AppBar,
  Toolbar,
  Button,
  useMediaQuery,
  Drawer,
  List,
  ListItem,
  ListItemText,
  useScrollTrigger
} from "@mui/material";
import CelebrationIcon from "@mui/icons-material/Celebration";
import CakeIcon from "@mui/icons-material/Cake";
import NaturePeopleIcon from "@mui/icons-material/NaturePeople";
import FavoriteIcon from "@mui/icons-material/Favorite";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import ChildCareIcon from "@mui/icons-material/ChildCare";
import GroupsIcon from "@mui/icons-material/Groups";
import MenuIcon from "@mui/icons-material/Menu";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import axios from "axios";

const categoryIcons = {
  Wedding: <CelebrationIcon sx={{ color: "#d32f2f" }} />,
  Birthday: <CakeIcon sx={{ color: "#ff9800" }} />,
  Outdoor: <NaturePeopleIcon sx={{ color: "#388e3c" }} />,
  Classic: <FavoriteIcon sx={{ color: "#1976d2" }} />,
  "Pre-Wedding": <FavoriteBorderIcon sx={{ color: "#e91e63" }} />,
  "Post-Wedding": <FavoriteIcon sx={{ color: "#f06292" }} />,
  "Baby Shoot": <ChildCareIcon sx={{ color: "#ffb300" }} />,
  Meetings: <GroupsIcon sx={{ color: "#1976d2" }} />
};

const transition = (props) => <Slide direction="up" {...props} />;

const NAV_LINKS = [
  { label: "Home", path: "/user-home" },
  { label: "Albums", path: "/user-albums" },
  { label: "Frames", path: "/user-frames" },
  { label: "Photo Selection", path: "/user-photo-selection" },
  { label: "Prices", path: "/user-prices" }, // <-- Make sure this is present!
  { label: "Contact", path: "/user-contact" },
  { label: "About", path: "/user-about" }
];

const HideOnScroll = (props) => {
  const { children } = props;
  const trigger = useScrollTrigger();

  return (
    <Slide appear={false} direction="down" in={!trigger}>
      {children}
    </Slide>
  );
};

const UserAlbums = () => {
  const [albumData, setAlbumData] = useState([]);
  const [open, setOpen] = useState(false);
  const [selectedAlbum, setSelectedAlbum] = useState(null);
  const [showMore, setShowMore] = useState(false);
  const [albumDesc, setAlbumDesc] = useState("");
  const [varietyPage, setVarietyPage] = useState(0);
  const VARIETIES_PER_PAGE = 5;
  const [weddingVarieties, setWeddingVarieties] = useState([]);
  const [footers, setFooters] = useState({});
  const clientMongoId = localStorage.getItem("clientMongoId");
  const userId = localStorage.getItem("userId"); // Store userId in localStorage after login
  const isMobile = useMediaQuery("(max-width:600px)");
  const [drawerOpen, setDrawerOpen] = useState(false);
  const studioName = localStorage.getItem("studioName") || "Studio";
  const [selectedVarieties, setSelectedVarieties] = useState([]);

  useEffect(() => {
    async function fetchAlbums() {
      if (!clientMongoId) return;
      try {
        const res = await axios.get(`https://studio-lc.onrender.com/api/clients/${clientMongoId}/albums`);
        setAlbumData(res.data.albums || []);
      } catch (err) {
        setAlbumData([]);
      }
    }
    fetchAlbums();
  }, [clientMongoId]);

  useEffect(() => {
    async function fetchAlbumDesc() {
      if (!clientMongoId) return;
      try {
        const res = await axios.get(`https://studio-lc.onrender.com/api/clients/${clientMongoId}/album-description`);
        setAlbumDesc(res.data.albumDescription || "");
      } catch (err) {
        setAlbumDesc("Explore our variety of albums, categories, and prices");
      }
    }
    fetchAlbumDesc();
  }, [clientMongoId]);

  useEffect(() => {
    async function fetchFooters() {
      if (!clientMongoId) return;
      try {
        const res = await axios.get(
          `https://studio-lc.onrender.com/api/clients/${clientMongoId}/footers`
        );
        setFooters(res.data.footers || {});
      } catch (err) {
        setFooters({});
      }
    }
    fetchFooters();
  }, [clientMongoId]);

  // Fetch selected varieties for this user
  useEffect(() => {
    async function fetchSelected() {
      if (!clientMongoId || !userId) return;
      try {
        const res = await axios.get(`https://studio-lc.onrender.com/api/clients/${clientMongoId}/users/${userId}`);
        setSelectedVarieties(res.data.albumselected || []);
      } catch {
        setSelectedVarieties([]);
      }
    }
    fetchSelected();
  }, [clientMongoId, userId]);

  const handleCardClick = (album) => {
    setSelectedAlbum(album);
    setOpen(true);
    setShowMore(false);
    setWeddingVarieties(album.varieties || []);
    setVarietyPage(0);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedAlbum(null);
    setShowMore(false);
  };

  const handleMoreInfo = () => {
    setShowMore(true);
  };

  const toggleDrawer = () => {
    setDrawerOpen(!drawerOpen);
  };

  // Select/Unselect handler for a variety
  const handleToggleSelectVariety = async (varietyPage) => {
    if (!selectedAlbum) return;
    const variety = weddingVarieties[varietyPage];
    if (!variety) return;
    const varietyId = `${selectedAlbum.title}:${variety.model}`;
    let updated;
    if (selectedVarieties.includes(varietyId)) {
      // Unselect: remove from array
      updated = selectedVarieties.filter(v => v !== varietyId);
    } else {
      // Select: add to array
      updated = [...selectedVarieties, varietyId];
    }
    setSelectedVarieties(updated);
    // Update in DB for this user
  await axios.put(`https://studio-lc.onrender.com/api/clients/${clientMongoId}/users/${userId}/albumselected`, { albumselected: updated });
  };

  return (
    <Box
          sx={{
            bgcolor: "#fff",
            minHeight: "100vh",
            width: "100%",
            overflowX: "hidden",mt:2
          }}
        >
      {/* App Bar for mobile */}
      {isMobile && (
        <AppBar position="fixed" sx={{ bgcolor: "#1976d2" }}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              aria-label="menu"
              onClick={toggleDrawer}
              sx={{ mr: 2 }}
            >
              <MenuIcon />
            </IconButton>
            <Typography variant="h6" sx={{ flexGrow: 1,  fontFamily: "Josefin Sans", }}>
              Studio Albums
            </Typography>
          </Toolbar>
        </AppBar>
      )}
      {/* Drawer for mobile menu */}
      <Drawer
        anchor="top"
        open={drawerOpen}
        onClose={toggleDrawer}
        sx={{
          "& .MuiDrawer-paper": {
            bgcolor: "#fff",
            p: 2,
            borderTopLeftRadius: 16,
            borderTopRightRadius: 16,
            boxShadow: "0 -4px 16px rgba(0, 0, 0, 0.1)",
            border: "none"
          }
        }}
      >
        <List>
          {albumData.map((album) => (
            <ListItem button key={album.title} onClick={() => handleCardClick(album)}>
              <ListItemText
                primary={album.title}
                secondary={album.desc}
                primaryTypographyProps={{ fontWeight: 700, color: "#1976d2" }}
                secondaryTypographyProps={{ color: "#666" }}
                sx={{ py: 1.5 }}
              />
            </ListItem>
          ))}
        </List>
      </Drawer>
      <HideOnScroll>
        <AppBar
          position="fixed"
          sx={{
            bgcolor: "#fff",
            boxShadow: 3,
            height: isMobile ? 56 : 80,
            zIndex: 1201
          }}
        >
          <Toolbar
            sx={{
              minHeight: isMobile ? 56 : 80,
              px: isMobile ? 1 : 3,
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: isMobile ? "space-between" : "center"
            }}
          >
            <Typography
              variant={isMobile ? "h5" : "h4"}
              sx={{
                fontFamily: "joesfin Sans",
                fontWeight: 900,
                color: "#8b5e3c",
                letterSpacing: 2,
                mr: isMobile ? 0 : 4,
                flexShrink: 0,
                fontFamily: "Josefin Sans",
              }}
            >
              {studioName}
            </Typography>
            {!isMobile && (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: 4,
                  flexGrow: 1
                }}
              >
                {NAV_LINKS.map((link) => (
                  <Button
                    key={link.label}
                    href={link.path}
                    sx={{
                      color: "#8b5e3c",
                      fontWeight: 700,
                      fontSize: 22,
                      textTransform: "none",
                      letterSpacing: 1.5,
                      fontFamily: "Josefin Sans",
                    }}
                  >
                    {link.label}
                  </Button>
                ))}
              </Box>
            )}
            {isMobile && (
              <IconButton
                edge="end"
                color="inherit"
                aria-label="menu"
                onClick={() => setDrawerOpen(true)}
                sx={{ ml: "auto" }}
              >
                <MenuIcon sx={{ color: "#8b5e3c", fontSize: 36, }} />
              </IconButton>
            )}
          </Toolbar>
        </AppBar>
      </HideOnScroll>
      <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
      >
        <Box sx={{ width: 220, mt: 6 }}>
          <List>
            {NAV_LINKS.map((link) => (
              <ListItem
                button
                key={link.label}
                component="a"
                href={link.path}
                onClick={() => setDrawerOpen(false)}
              >
                <ListItemText
                  primary={link.label}
                  primaryTypographyProps={{
                    fontSize: 20,
                    fontWeight: 600,
                    color: "#8b5e3c",
                    fontFamily: "Josefin Sans",
                  }}
                />
              </ListItem>
            ))}
          </List>
        </Box>
      </Drawer>
      <Box sx={{ height: isMobile ? 56 : 80 }} />
      <Typography
        variant="h3"
        sx={{
          display: "block",
          textAlign: "center",
          fontWeight: 700,
          mb: 4,
          width: { xs: "100%", sm: "94%" },
          px: { xs: 2, sm: 6 },
          py: 1.5,
          borderRadius: 6,
          boxShadow: "0 2px 12px 0 rgba(194, 155, 99, 0.10)",
          mx: "auto",
            fontFamily: "Josefin Sans",
          color: "#8b5e3c",
          letterSpacing: 2,
          background: "linear-gradient(90deg, #fff8e1 60%, #ffe0b2 100%)"
        }}
      >
        Albums
      </Typography>
      <Typography
        variant="h6"
        sx={{
          textAlign: "center",
          color: "#333",
          fontWeight: 500,
          mb: 5,
          ml: 2,
          fontFamily: "Jost",
          width: { xs: "90%", sm: "70%", md: "95%" },
        }}
      >
        {albumDesc}
      </Typography>
      <Grid container spacing={{ xs: 2, sm: 6, md: 10 }} justifyContent="center">
        {albumData.map((album, idx) => (
          <Grid item xs={12} sm={6} md={6} lg={6} key={album.title}>
            <Card
              sx={{
                width: 450,           // Fixed width
                minWidth: 450,
                maxWidth: 450,
                borderRadius: 6,
                background: "linear-gradient(135deg, #fff, #fff8e1 60%, #fbe9e7 100%)",
                border: "1.5px solid #f5e1c1",
                boxShadow: "0 8px 32px rgba(194, 155, 99, 0.13)",
                transition: "box-shadow 0.3s, transform 0.3s",
                "&:hover": {
                  boxShadow: "0 16px 40px rgba(194, 155, 99, 0.22)",
                  transform: "scale(1.045)"
                },
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start"
              }}
              onClick={() => handleCardClick(album)}
            >
              <CardActionArea>
                <CardMedia
                  component="img"
                  height="200"
                  image={album.img}
                  alt={album.title}
                  sx={{
                    borderTopLeftRadius: 16,
                    borderTopRightRadius: 16,
                    animation: "albumFade 2s"
                  }}
                />
                <CardContent
                  sx={{
                    flex: 1,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "flex-start",
                    minHeight: 0,
                    overflow: "hidden",
                    pb: "0 !important"
                  }}
                >
                  <Stack direction="row" alignItems="center" justifyContent="center" spacing={1} sx={{ mb: 1 }}>
                    {categoryIcons[album.category]}
                    <Chip sx={{background:"#8b5e3c",color:"#fff", fontFamily:"Josefin Sans", }} label={album.category}  variant="outlined" />
                  </Stack>
                  <Typography
                    gutterBottom
                    variant="h5"
                    component="div"
                    sx={{
                      fontWeight: 700,
                      color: "#a67c52", // sand color
                      textAlign: "center",
                      fontFamily: "Josefin Sans",
                    }}
                  >
                    {album.title}
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      textAlign: "center",
                      fontWeight: 500,
                      mb: 1,
                      color: "#8b5e3c" ,
                      fontFamily: "Jost",
                      wordBreak: "break-word",
                      overflowWrap: "break-word",
                      maxWidth: "100%",
                      fontSize: 16,
                      lineHeight: 1.5,
                      maxHeight: 48, // About 2-3 lines
                      overflow: "hidden",
                      display: "-webkit-box",
                      WebkitLineClamp: 3,
                      WebkitBoxOrient: "vertical"
                    }}
                  >
                    {album.desc}
                  </Typography>
                  <Typography
                    variant="subtitle2"
                    sx={{
                      textAlign: "center",
                      color: "#a67c52", // sand color
                      fontWeight: 700,
                      fontSize: 16,
                      fontFamily: "Josefin Sans",
                    }}
                  >
                    {album.price}
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>
      {/* Album Details Dialog */}
      <Dialog
        open={open}
        onClose={handleClose}
        TransitionComponent={transition}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 4,
            boxShadow: 8,
            bgcolor: "#fff",
            animation: "albumDialogFade 1s"
          }
        }}
      >
        {selectedAlbum && (
          <>
            <DialogTitle
              sx={{
                fontWeight: 700,
                color: "#a67c52",
                textAlign: "center",
                fontSize: 28,
                 fontFamily: "Josefin Sans",
                letterSpacing: 2
              }}
            >
              {selectedAlbum.title}
            </DialogTitle>
            <DialogContent>
              <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                <img
                  src={selectedAlbum.img}
                  alt={selectedAlbum.title}
                  style={{
                    width: "100%",
                    maxWidth: 320,
                    height: 180,
                    objectFit: "cover",
                    borderRadius: 12,
                    marginBottom: 16,
                    boxShadow: "0 4px 16px rgba(25,118,210,0.10)",
                    animation: "albumFade 2s"
                  }}
                />
                <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 2 }}>
                  {categoryIcons[selectedAlbum.category]}
                  <Chip sx={{background:"#8b5e3c",color:"#fff", fontFamily:"Josefin Sans", }}  label={selectedAlbum.category}  variant="outlined" />
                  <Chip  label={selectedAlbum.price} color="success" variant="filled" />
                </Stack>
                <Typography
                  variant="body1"
                  sx={{
                    color: "#333",
                    fontWeight: 500,
                    textAlign: "center",
                    whiteSpace: "pre-line",
                    mb: 2,
                    fontSize: 18,
                      fontFamily: "Jost",
                    animation: "albumTextAnim 1.2s"
                  }}
                >
                  {selectedAlbum.details}
                </Typography>
                {/* More Info Button at the bottom */}
                {!showMore && (
                  <Box sx={{ mt: 2, width: "100%", display: "flex", justifyContent: "center" }}>
                    <button
                      style={{
                        background: "#8b5e3c",
                        color: "#fff",
                        border: "none",
                        borderRadius: 6,
                        padding: "8px 24px",
                        fontWeight: 700,
                        fontSize: 16,
                        cursor: "pointer",
                        fontFamily: "Jost",
                        boxShadow: "0 2px 8px rgba(25,118,210,0.10)",
                        transition: "background 0.2s"
                      }}
                      onClick={handleMoreInfo}
                    >
                      More Info
                    </button>
                  </Box>
                )}
                {showMore && (
                  <Box sx={{ mt: 3, width: "100%", display: "flex", flexDirection: "column", alignItems: "center" }}>
                    <Typography variant="h6" sx={{ color: "#a67c52", fontWeight: 700, mb: 2, textAlign: "center",  fontFamily: "Josefin Sans", }}>
                      {selectedAlbum.category} Album Varieties & Prices
                    </Typography>
                   
                    {/* Arrow navigation below the cards */}
                    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", mt: 2 }}>
                      {weddingVarieties.length > 0 && (
                        <Box
                          sx={{
                            width: 320,
                            minHeight: 340,
                            bgcolor: "linear-gradient(135deg, #fff, #fff8e1 60%, #fbe9e7 100%)",
                            border: "1.5px solid #f5e1c1",
                            borderRadius: 6,
                            boxShadow: "0 8px 32px rgba(194, 155, 99, 0.13)",
                            p: 2,
                            mx: 2,
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            animation: "fadeInVariety 0.5s"
                          }}
                        >
                          {/* Only show the current variety page */}
                          {(() => {
                            const variety = weddingVarieties[varietyPage];
                            if (!variety) return null;
                            return (
                              <>
                                <img
                                  src={variety.img || "https://via.placeholder.com/260x140?text=Variety"}
                                  alt={variety.model}
                                  style={{
                                    width: "100%",
                                    maxWidth: 260,
                                    height: 140,
                                    objectFit: "cover",
                                    borderRadius: 8,
                                    marginBottom: 12,
                                    boxShadow: "0 2px 8px rgba(25,118,210,0.10)"
                                  }}
                                />
                                <Typography variant="subtitle1" sx={{ fontWeight: 1000, color: "#a67c52", mb: 1,  fontFamily: "Josefin Sans", }}>
                                  {variety.model}
                                </Typography>
                                <Typography variant="body2" sx={{ color: "#8b5e3c", fontWeight: 600,  fontFamily: "Jost", }}>
                                  Size: {variety.size}
                                </Typography>
                                <Typography variant="body2" sx={{ color: "#8b5e3c", fontWeight: 600,  fontFamily: "Jost", }}>
                                  Images: {variety.images}
                                </Typography>
                                <Typography variant="body2" sx={{ color: "#8b5e3c", fontWeight: 600,  fontFamily: "Jost", }}>
                                  Pages: {variety.pages}
                                </Typography>
                                <Typography variant="body2" sx={{ color: "#d32f2f", fontWeight: 700, mt: 1 ,  fontFamily: "Jost",}}>
                                  Price: {variety.price}
                                </Typography>
                              {selectedVarieties.includes(`${selectedAlbum.title}:${weddingVarieties[varietyPage]?.model}`) ? (
  <Button
    onClick={() => handleToggleSelectVariety(varietyPage)}
    sx={{
      mt: 2,
      width: "40%",
      fontWeight: 700,
      fontFamily: "Jost",
      fontSize: 17,
      letterSpacing: 1,
      borderRadius: 3,
      boxShadow: "0 4px 16px #43ea7b33",
      background: "linear-gradient(90deg,#43ea7b 0%,#1de9b6 100%)",
      color: "#fff",
      border: "2px solid #66ec8aff",
      transition: "all 0.2s",
      "&:hover": {
        background: "linear-gradient(90deg,#00bfa5 0%,#43ea7b 100%)",
        color: "#fff",
        boxShadow: 6,
        transform: "scale(1.05)"
      }
    }}
  >
    Unselect
  </Button>
) : (
  <Button
    onClick={() => handleToggleSelectVariety(varietyPage)}
    sx={{
      mt: 2,
      width: "40%",
      fontWeight: 700,
      fontSize: 17,
        fontFamily: "Jost",
      letterSpacing: 1,
      borderRadius: 3,
      boxShadow: "0 4px 16px #1976d233",
      background: "linear-gradient(90deg,#fff 0%,#e3f2fd 100%)",
      color: "#1976d2",
      border: "2px solid #1976d2",
      transition: "all 0.2s",
      "&:hover": {
        background: "linear-gradient(90deg,#e3f2fd 0%,#fff 100%)",
        color: "#1976d2",
        boxShadow: 6,
        transform: "scale(1.05)"
      }
    }}
  >
    Select
  </Button>
)}
                              </>
                            );
                          })()}
                        </Box>
                      )}
                      {/* Arrows below the card */}
                      <Box sx={{ display: "flex", justifyContent: "center", mt: 1, gap: 2 }}>
                        <IconButton
                          disabled={varietyPage === 0}
                          onClick={() => setVarietyPage(varietyPage - 1)}
                          sx={{
                            bgcolor: "rgba(25, 118, 210, 0.08)",
                            color: "#1976d2",
                            borderRadius: "50%",
                            boxShadow: 2,
                            mx: 1,
                            transition: "all 0.2s",
                            "&:hover": {
                              bgcolor: "#1976d2",
                              color: "#fff",
                              transform: "scale(1.15)",
                              boxShadow: 4,
                            },
                            "&.Mui-disabled": {
                              color: "#bdbdbd",
                              bgcolor: "rgba(0,0,0,0.03)",
                            },
                            fontSize: 32,
                          }}
                        >
                          <ArrowBackIosNewIcon fontSize="inherit" />
                        </IconButton>
                        <IconButton
                          disabled={varietyPage >= weddingVarieties.length - 1}
                          onClick={() => setVarietyPage(varietyPage + 1)}
                          sx={{
                            bgcolor: "rgba(25, 118, 210, 0.08)",
                            color: "#1976d2",
                            borderRadius: "50%",
                            boxShadow: 2,
                            mx: 1,
                            transition: "all 0.2s",
                            "&:hover": {
                              bgcolor: "#1976d2",
                              color: "#fff",
                              transform: "scale(1.15)",
                              boxShadow: 4,
                            },
                            "&.Mui-disabled": {
                              color: "#bdbdbd",
                              bgcolor: "rgba(0,0,0,0.03)",
                            },
                            fontSize: 32,
                          }}
                        >
                          <ArrowForwardIosIcon fontSize="inherit" />
                        </IconButton>
                      </Box>
                    </Box>
                  </Box>
                )}
              </Box>
            </DialogContent>
          </>
        )}
      </Dialog>
      {/* Footer Section */}
      {/* Footer Section */}
           <Box
                  sx={{
                    bgcolor: "#a67c52",
                    color: "#fff",
                     fontFamily: "Josefin Sans",
                    mt: 4,
                    pt: 4,
                    pb: 2
                  }}
                >
                  <Grid container spacing={2} sx={{ maxWidth: 1300, mx: "auto" }}>
                    {/* Left Column */}
                    <Grid item xs={12} md={3} sx={{ml: { xs: 3 }, mt: { xs: 6,  }}}>
                      <Typography variant="h5" sx={{ fontWeight: 700,  fontFamily: "Josefin Sans",  }}>
                        {footers.studio}
                      </Typography>
                      <Typography variant="body1" sx={{  fontFamily: "Jost",fontSize:17}}>{footers.tag}</Typography>
                      <Typography variant="body2" sx={{  fontFamily: "Jost",fontSize:17}}>{footers.handle}</Typography>
                    </Grid>
                    {/* Center Column */}
                    <Grid
                      item
                      xs={12}
                      md={6}
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        ml: { xs: 0, md: 12 }
                      }}
                    >
                      <Typography
                        variant="body1"
                        sx={{
                          textAlign: "center",
                          fontSize: 18,
                          mb: 2,
                          fontFamily: "Jost",
                        }}
                      >
                        {footers.text}
                      </Typography>
                    </Grid>
                    {/* Right Column */}
                    <Grid item xs={12} md={3}>
                      <Box sx={{ display: "flex", gap: 2, mb: 2,ml: { xs: 3, md: 15 } ,mt: { xs: 6, md: 5 } }}>
                        {/* WhatsApp */}
                        <a href="https://wa.me/919123456789" target="_blank" rel="noopener noreferrer">
                          <Box sx={{ bgcolor: "#25D366", borderRadius: "50%", p: 1 }}>
                            <img src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg" alt="WhatsApp" style={{ width: 28, height: 28 }} />
                          </Box>
                        </a>
                        {/* Instagram */}
                        <a href="https://instagram.com/" target="_blank" rel="noopener noreferrer">
                          <Box sx={{ bgcolor: "#fff", borderRadius: "50%", p: 1 }}>
                            <img src="https://upload.wikimedia.org/wikipedia/commons/a/a5/Instagram_icon.png" alt="Instagram" style={{ width: 28, height: 28 }} />
                          </Box>
                        </a>
                        {/* Gmail */}
                        <a href="mailto:studioartmdu@gmail.com" target="_blank" rel="noopener noreferrer">
                          <Box sx={{ bgcolor: "#fff", borderRadius: "50%", p: 1 }}>
                            <img src="https://upload.wikimedia.org/wikipedia/commons/4/4e/Gmail_Icon.png" alt="Gmail" style={{ width: 28, height: 28 }} />
                          </Box>
                        </a>
                        {/* YouTube */}
                        <a href="https://youtube.com/" target="_blank" rel="noopener noreferrer">
                          <Box sx={{ bgcolor: "#fff", borderRadius: "50%", p: 1 }}>
                            <img src="https://upload.wikimedia.org/wikipedia/commons/4/42/YouTube_icon_%282013-2017%29.png" alt="YouTube" style={{ width: 28, height: 28 }} />
                          </Box>
                        </a>
                      </Box>
                    </Grid>
                    {/* Bottom Row */}
                    <Grid
                      item
                      xs={12}
                      sx={{
                        borderTop: "1px solid #fff2",
                        mt: 0,
                        ml: {xs:5, md:50},
                        pt: 2,
                        display: "flex",
                        flexDirection: { xs: "column", md: "row" },
                        justifyContent: "space-between",
                        alignItems: "center"
                      }}
                    >
                      <Typography variant="body2" sx={{ fontSize: 16,  fontFamily: "Josefin Sans", }}>
                        {footers.copyright}
                      </Typography>
                      <Typography variant="body2" sx={{ fontSize: 16,  fontFamily: "Josefin Sans", }}>
                        {footers.made}
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>
      {/* Animation styles */}
      <style>
        {`
          @keyframes albumFade {
            0% { opacity: 0; transform: scale(0.96);}
            100% { opacity: 1; transform: scale(1);}
          }
          @keyframes albumDialogFade {
            0% { opacity: 0; transform: translateY(40px);}
            100% { opacity: 1; transform: translateY(0);}
          }
          @keyframes albumTextAnim {
            0% { opacity: 0; transform: translateY(20px);}
            100% { opacity: 1; transform: translateY(0);}
          }
          @keyframes fadeInVariety {
            0% { opacity: 0; transform: translateY(30px);}
            100% { opacity: 1; transform: translateY(0);}
          }
        `}
      </style>
    </Box>
  );
};

export default UserAlbums;